import Emitter from 'utils-lib/dist/emitter';

export default {
  mixins: [
    Emitter,
  ],
  watch: {
    curValue(value, oldValue) {
      // 值发生改变
      if (JSON.stringify(oldValue) !== JSON.stringify(value)) {
        // 触发form中的change事件
        this.dispatch('hive-form-item', 'form.change', value);
      }
    },
  },
};
